import React, { Component } from 'react'
import styles from './index.module.less'

import Context from './context'
import { IMachineConfig, IStatistics } from './types'
import { EditConfigType, EditorFlagEum } from '@/typings/types'
import ShareBefore from './share-before'
import ShareAfter from './share-after'
import ShareInvite from './share-invite'
import { getSubsidyInfo } from '@/components/poizon-fission/apis'
import languages from './config/languages'
import jockey from '@/utils/jockey'
import { compareVersion, getAppVersion } from '@/utils/appUtils/getDevice'
import myEmitter from '@/utils/event'

class Index extends Component<
  {
    editConfig: EditConfigType
    propsConfig: IMachineConfig
  },
  IStatistics
> {
  editConf: EditConfigType
  linkRule: string
  static config = {
    name: 'poizon-fission',
  }

  constructor(props) {
    super(props)
    this.editConf = this.props.editConfig
    this.state = {
      hasInviteUser: false,
      curMonthWillRewardAmt: '0.00',
      rewardAmt: '0.00',
      currency: '',
      currencySymbol: '',
      inviteUsers: 0,
      inviteSettledUsers: 0,
      rightsSelectFlag: true,
      canSelectRights: [],
      displayNewGiftBag: false,
    }
    const { lang, local } = this.editConf
    this.linkRule = `https://fast.poizon.com/poizon/detail/${lang}/${local}/616bddd7695f32420f171791`
  }

  componentDidMount() {
    /* 编辑状态下不执行 */
    const { editorFlag, lang, local, query } = this.editConf

    if (editorFlag !== EditorFlagEum.detail) {
      return
    }
    const { inside, outside } = languages[lang].pageTitle
    if (this.isOutside(query)) {
      this.resetPageTitle(outside)
      return
    }
    this.resetPageTitle(inside)

    const params = {
      activityType: '1',
      countryCode: local,
      language: lang,
    }

    this.getStatistics(params)

    this.activityRule()

    myEmitter.on('handleShareResult', this, function () {
      this.getStatistics(params)
    })
  }

  getStatistics(params) {
    getSubsidyInfo(params).then(({ code, data }) => {
      if (code !== 200) {
        return
      }
      this.setState(data)
    })
  }

  resetPageTitle(title: string) {
    setTimeout(() => {
      jockey.setTitle(title)
    })
  }

  isOutside(query: { [key: string]: any }) {
    return query?.run === 'outside'
  }

  activityRule() {
    const link = this.linkRule
    if (compareVersion(getAppVersion(), '2.6.510') !== -1) {
      jockey.setNavigationBarButtonList({
        list: [
          {
            type: 1,
            imgUrl: 'https://cdn.poizon.com/node-common/927266b6d5444ec5b26a36a0b5b3390e.png',
            link: `https://**.com/router/web/browser?url=${link}`,
          },
        ],
      })
    } else {
      jockey.registerBarAction({
        iconUrl: 'https://cdn.poizon.com/node-common/927266b6d5444ec5b26a36a0b5b3390e.png',
        routerUrl: link,
      })
    }
  }

  sceneComponent() {
    const {
      editConfig: { query },
    } = this.props

    const { local } = this.editConf
    const propsConfig = this.props.propsConfig || {}
    const machineConfig = propsConfig?.[local] || propsConfig

    if (this.isOutside(query)) {
      return (
        <ShareInvite
          linkRule={this.linkRule}
          nickname={query?.nickname}
          inviteCode={query?.referralCode}
          portrait={
            query?.portrait ||
            'https://cdn.poizon.com/node-common/edbc42094d8eba30d1a6985f96a01a0e.png'
          }
          {...machineConfig}
          {...this.props}
        />
      )
    }

    if (this.state.hasInviteUser) {
      return <ShareAfter {...machineConfig} {...this.state} />
    }
    const deriveOutside = query?.derive === 'arouse'
    return <ShareBefore {...machineConfig} isDeriveOutside={deriveOutside} />
  }

  render() {
    const { lang, local, id } = this.editConf

    const language = languages[lang]
    let equity = ''

    // 买卖家权益
    if (local === 'HK') {
      equity = 'both'
    }
    // 卖家权益
    else if (['TW', 'MO', 'JP', 'US'].includes(local)) {
      equity = 'seller'
    }
    // 无大礼包
    else {
      equity = 'special'
    }

    return (
      <Context.Provider value={{ pageId: id, activityType: '1', equity, lang, local, ...language }}>
        <div className={styles.fission}>{this.sceneComponent()}</div>
      </Context.Provider>
    )
  }
}

export default Index
